(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bh-app-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const states = new WeakMap();
    let scheduled = false;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const getHeroes = () => Array.from(document.querySelectorAll('[data-bh-app-goals]'));

    const measureProgress = (hero) => {
      const track = hero.querySelector('[data-bh-app-goal-track]');
      if (!track) return 0;

      const rect = track.getBoundingClientRect();
      const range = Math.max(1, track.offsetHeight - window.innerHeight);
      return clamp(-rect.top / range, 0, 1);
    };

    const renderHero = (hero, progress) => {
      const frames = Array.from(hero.querySelectorAll('[data-bh-app-goal-frame]'));
      if (!frames.length) return;

      const active = Math.min(frames.length - 1, Math.floor(progress * frames.length));

      frames.forEach((frame, index) => {
        frame.style.setProperty('--bh-app-frame-opacity', index === active ? '1' : '0');
        frame.classList.toggle('is-active', index === active);
        frame.setAttribute('aria-hidden', index === active ? 'false' : 'true');
      });

      hero.style.setProperty('--bh-app-left-shift', (-8 + progress * 16).toFixed(2) + 'px');
      hero.style.setProperty('--bh-app-right-shift', (8 - progress * 16).toFixed(2) + 'px');
    };

    const syncHero = (hero) => {
      const progress = measureProgress(hero);
      states.set(hero, { current: progress, target: progress });
      renderHero(hero, progress);
    };

    const tick = () => {
      scheduled = false;
      if (reduced.matches) return;

      let keepAnimating = false;

      getHeroes().forEach((hero) => {
        const state = states.get(hero);
        if (!state) return;

        const difference = state.target - state.current;
        if (Math.abs(difference) < 0.0004) {
          state.current = state.target;
        } else {
          state.current += difference * 0.18;
          keepAnimating = true;
        }

        renderHero(hero, state.current);
      });

      if (keepAnimating) requestRender();
    };

    const requestRender = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(tick);
    };

    const updateTargets = () => {
      if (reduced.matches) return;

      getHeroes().forEach((hero) => {
        const state = states.get(hero);
        if (state) state.target = measureProgress(hero);
        else syncHero(hero);
      });

      requestRender();
    };

    const syncAll = () => getHeroes().forEach(syncHero);

    syncAll();
    requestAnimationFrame(syncAll);

    window.addEventListener('pageshow', syncAll);
    window.addEventListener('load', syncAll, { once: true });
    window.addEventListener('scroll', updateTargets, { passive: true });
    window.addEventListener('resize', updateTargets, { passive: true });
    document.addEventListener('shopify:section:load', syncAll);

    const handleMotionChange = () => {
      syncAll();
      if (!reduced.matches) updateTargets();
    };

    if (reduced.addEventListener) reduced.addEventListener('change', handleMotionChange);
    else if (reduced.addListener) reduced.addListener(handleMotionChange);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bh-app-trophies"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let scheduled = false;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const getSections = () => Array.from(document.querySelectorAll('[data-bh-app-trophies]'));

    const getProgress = (section) => {
      const track = section.querySelector('[data-bh-app-trophies-track]');
      if (!track) return 0;

      const rect = track.getBoundingClientRect();
      const range = Math.max(1, track.offsetHeight - window.innerHeight);
      return clamp(-rect.top / range, 0, 1);
    };

    const render = (section) => {
      const frames = Array.from(section.querySelectorAll('[data-bh-app-trophy-frame]'));
      if (!frames.length) return;

      const active = reducedMotion.matches
        ? 0
        : Math.min(frames.length - 1, Math.floor(getProgress(section) * frames.length));

      frames.forEach((frame, index) => {
        const isActive = index === active;
        frame.style.opacity = isActive ? '1' : '0';
        frame.classList.toggle('is-active', isActive);
        frame.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    };

    const renderAll = () => getSections().forEach(render);

    const requestRender = () => {
      if (scheduled || reducedMotion.matches) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        renderAll();
      });
    };

    const preloadFrames = (section) => {
      section.querySelectorAll('.bh-app-trophies__image').forEach((image) => {
        const preload = new Image();
        preload.srcset = image.srcset;
        preload.sizes = image.sizes;
        preload.src = image.currentSrc || image.src;
      });
    };

    const observeForPreload = () => {
      if (!('IntersectionObserver' in window)) {
        getSections().forEach(preloadFrames);
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          preloadFrames(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '200% 0px' });

      getSections().forEach((section) => observer.observe(section));
    };

    renderAll();
    requestAnimationFrame(renderAll);
    observeForPreload();

    window.addEventListener('pageshow', renderAll);
    window.addEventListener('load', renderAll, { once: true });
    window.addEventListener('scroll', requestRender, { passive: true });
    window.addEventListener('resize', requestRender, { passive: true });
    document.addEventListener('shopify:section:load', () => {
      renderAll();
      observeForPreload();
    });

    const handleMotionChange = () => renderAll();
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', handleMotionChange);
    else if (reducedMotion.addListener) reducedMotion.addListener(handleMotionChange);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bh-device-scroll-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const showcases = Array.from(document.querySelectorAll('[data-bh-device-showcase]'));
    if (!showcases.length) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia('(max-width: 749px)');
    const states = new WeakMap();
    let scheduled = false;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const smoothstep = (value) => value * value * (3 - 2 * value);

    const measureProgress = (showcase) => {
      const rect = showcase.getBoundingClientRect();
      const range = Math.max(1, showcase.offsetHeight - window.innerHeight);
      return clamp(-rect.top / range, 0, 1);
    };

    const easedPosition = (progress, count) => {
      if (count <= 1) return 0;
      const raw = progress * (count - 1);
      const segment = Math.min(count - 2, Math.floor(raw));
      const local = clamp(raw - segment, 0, 1);
      return segment + smoothstep(local);
    };

    const renderShowcase = (showcase, progress) => {
      const frames = Array.from(showcase.querySelectorAll('[data-bh-device-frame]'));
      const stories = Array.from(showcase.querySelectorAll('[data-bh-device-story]'));
      const count = Math.min(frames.length, stories.length);
      if (!count) return;

      const position = easedPosition(progress, count);
      const active = Math.round(position);

      showcase.style.setProperty('--bh-progress', progress.toFixed(4));

      frames.forEach((frame, index) => {
        const delta = index - position;
        const distance = Math.abs(delta);
        const opacity = clamp(1 - distance, 0, 1);
        const x = delta * (mobile.matches ? 1.15 : 1.4);
        const scale = 1 - Math.min(distance, 1) * 0.008;

        frame.style.setProperty('--bh-frame-opacity', opacity.toFixed(4));
        frame.style.transform =
          'translate3d(' + x.toFixed(3) + '%, 0, 0) scale(' + scale.toFixed(4) + ')';
        frame.classList.toggle('is-active', index === active);
        frame.setAttribute('aria-hidden', index === active ? 'false' : 'true');
      });

      stories.forEach((story, index) => {
        const delta = index - position;
        const distance = Math.abs(delta);
        const opacity = clamp(1 - distance * 1.8, 0, 1);
        const y = delta * (mobile.matches ? 10 : 14);

        story.style.setProperty('--bh-story-opacity', opacity.toFixed(4));
        story.style.transform = 'translate3d(0, ' + y.toFixed(2) + 'px, 0)';
        story.classList.toggle('is-active', index === active);
        story.setAttribute('aria-hidden', index === active ? 'false' : 'true');
      });

      const counter = showcase.querySelector('.bh-device-showcase__progress-count');
      if (counter) {
        counter.textContent =
          String(active + 1).padStart(2, '0') + ' / ' + String(count).padStart(2, '0');
      }
    };

    const tick = () => {
      scheduled = false;
      if (reduced.matches) return;

      let keepAnimating = false;

      showcases.forEach((showcase) => {
        const state = states.get(showcase);
        if (!state) return;

        const smoothing = mobile.matches ? 0.2 : 0.16;
        const difference = state.target - state.current;

        if (Math.abs(difference) < 0.0004) {
          state.current = state.target;
        } else {
          state.current += difference * smoothing;
          keepAnimating = true;
        }

        renderShowcase(showcase, state.current);
      });

      if (keepAnimating) requestRender();
    };

    const requestRender = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(tick);
    };

    const updateTargets = () => {
      if (reduced.matches) return;

      showcases.forEach((showcase) => {
        const state = states.get(showcase);
        if (state) state.target = measureProgress(showcase);
      });

      requestRender();
    };

    const syncImmediately = () => {
      showcases.forEach((showcase) => {
        const progress = measureProgress(showcase);
        const state = states.get(showcase);

        if (state) {
          state.current = progress;
          state.target = progress;
        } else {
          states.set(showcase, { current: progress, target: progress });
        }

        renderShowcase(showcase, progress);
      });
    };

    syncImmediately();
    requestAnimationFrame(syncImmediately);

    window.addEventListener('pageshow', syncImmediately);
    window.addEventListener('load', syncImmediately, { once: true });
    window.addEventListener('scroll', updateTargets, { passive: true });
    window.addEventListener('resize', updateTargets, { passive: true });

    const handleMotionChange = () => {
      showcases.forEach((showcase) => {
        const progress = measureProgress(showcase);
        const state = states.get(showcase);
        if (state) {
          state.current = progress;
          state.target = progress;
        }
        renderShowcase(showcase, progress);
      });
    };

    if (reduced.addEventListener) reduced.addEventListener('change', handleMotionChange);
    else if (reduced.addListener) reduced.addListener(handleMotionChange);

    if (mobile.addEventListener) mobile.addEventListener('change', updateTargets);
    else if (mobile.addListener) mobile.addListener(updateTargets);
  })();

  } catch(e) { console.error(e); }
})();
})();
